import i18n from "i18next";

import type { CellValue } from "../Table/types/types";
import { TagStyle } from "../Tag/TagStyle";

interface CellColorBadgeProps {
    cellValue: CellValue;
}

export const HtmlStatusColorBadgeComponent = ({ cellValue }: CellColorBadgeProps) => {
    const isInactive = !cellValue || cellValue === "NOT_ACTIVE";
    return (
        <TagStyle $variant={isInactive ? "lightPink" : "heroGreen"}>
            {isInactive ? i18n.t("enum.status.notActive") : i18n.t("enum.status.active")}
        </TagStyle>
    );
};
